import { ShoppingCartItem } from '../index';
import { formatPrice, getNumberOfGuests } from '@fshr/shared';
import { formatDateRange } from '@micro-apps/shared';
import { useTranslations } from '@fshr/context/i18n-context';
import { BasketItem } from '../ShoppingCartSummary/ShoppingCartSummary';
import { Oj } from '@fshr/shared/types';
import { IconWarning } from '../../icon';
import HorizontalLine from '../../horizontal-line';
import { cn } from '@fshr/shared-react';

export default function EventProductsOutsideDates({
	eventProductsOutsideDates = [],
	formattedStayDateRange,
	removeItem,
	handleShowInfoModal,
	highlightError,
}: {
	eventProductsOutsideDates: BasketItem[];
	formattedStayDateRange?: string;
	removeItem: ({ productId }: { productId: string }) => void;
	handleShowInfoModal: (hp: Oj.hotelProduct, priceStr: string) => void;
	highlightError?: boolean;
}) {
	const t = useTranslations();

	return (
		<div className="">
			<div
				className={cn(
					'spacing-card-padding-xs flex flex-row justify-start items-start spacing-inline-xs rounded-[5px]',
					{
						'bg-warning-container-subtle': !highlightError,
						'bg-error-container-subtle': highlightError,
					}
				)}
			>
				<div className="flex justify-start align-start">
					<IconWarning />
				</div>
				<div className="flex flex-col">
					<span className="text-label text-[12px]">{t('Outstanding Itinerary Items')}</span>
					<span className="text-caption">
						{t(
							`The following items are outside your ${formattedStayDateRange} stay dates. You must remove them in order to checkout.`
						)}
					</span>
				</div>
			</div>
			<div className="flex flex-col spacing-card-padding-xs bg-surface-raised-subtle spacing-stack-m">
				{eventProductsOutsideDates.map((product: any, index: number) => {
					const {
						date,
						productId,
						name,
						productTotal,
						onRequestEventProductType,
						price,
						numAdults,
						numChildren,
						images,
					} = product;

					return (
						<div className="flex flex-col spacing-stack-m">
							<div className="flex flex-col spacing-stack-xs" key={productId}>
								<span className="text-label">{formatDateRange(date)}</span>
								<ShoppingCartItem
									name={name}
									duration={price?.priceName}
									numberOfPeople={getNumberOfGuests({
										t,
										numberOfAdults: numAdults,
										numberOfChildren: numChildren,
									})}
									price={productTotal?.totalPrice?.amount}
									currencyCode={productTotal?.totalPrice?.currencyCode}
									insideCart={true}
									image={images?.[0]?.url}
									onRequestEventProductType={onRequestEventProductType}
									unitType={price?.priceDetail}
									showInfoModal={() => {
										const hotelProduct = {
											productId,
											name,
											productTotal,
											price,
											numAdults,
											numChildren,
										};
										handleShowInfoModal(
											hotelProduct,
											formatPrice({
												value: productTotal.totalPrice.amount,
												currencyCode: productTotal.totalPrice.currencyCode,
											})
										);
									}}
									removeItem={() => removeItem({ productId })}
									isOutsideDates
								/>
							</div>
							{index < eventProductsOutsideDates.length - 1 && (
								<HorizontalLine additionalClasses="border-border-subtle" />
							)}
						</div>
					);
				})}
			</div>
		</div>
	);
}
